import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

function AppLayout({ children }) {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

    return (
        <div className="min-h-screen bg-gray-50 pt-16">
            <Header toggleSidebar={toggleSidebar} />
            <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

            {/* Main Content */}
            <main className="ml-0 md:ml-[280px] p-4 md:p-8">
                {children}
            </main>
        </div>
    );
}

export default AppLayout;

